import cc from 'classcat';
import { jsx } from 'react/jsx-runtime';
import { svgCls } from './styles/svg.js';

const KiteShape = ({
  fillColor = "currentColor",
  shapeRef,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  strokeColor,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx("svg", {
    ...svgProps,
    className: cc([svgCls, svgProps.className]),
    ref: shapeRef,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 364.6 446.9",
    fill: fillColor,
    children: /*#__PURE__*/jsx("path", {
      d: "M0 176.3l182.3 270.6 182.3-270.6L182.3 0z"
    })
  });
};

export { KiteShape };
//# sourceMappingURL=KiteShape.js.map
